import { PopoverGroupOptionsMixin } from 'trunks/vue/admin/components/popover_group_options.js';

export default Vue.extend({
  mixins: [PopoverGroupOptionsMixin],

  template: `
    <popover-group-options optionsFilterPlaceholder='搜索标签'
                           :initialSelectedOptionIds='parsedInitialSelectedOptionIds'
                           optionsUrl='/tag_groups/receipt'
                           :formatDataFunc='formatTagGroups'
                           ref='popoverGroupOptionsRef'
                           @cancelClicked='cancelFunc'
                           @submitClicked='submitFunc'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='tip'>
          <i class='slp-origin' :style='{ color: option.color }'></i>
        </div>
        <div class='content'>
          <span>{{ option.name }}</span>
        </div>
        <i class='tip primary-text' :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
      </template>

      <div slot='filter-blankslate' class='list-group'>
        <div class="list-group-name">没有相关的搜索结果</div>
      </div>

      <div slot='options-blankslate' class='list-group'>
        <div class="list-group-name">没有“标签”</div>
      </div>
    </popover-group-options>
  `,

  props: {
    initialSelectedOptionIds: {
      type: Array,
    },
  },

  data() {
    return {
      tagGroups: [],
      parsedInitialSelectedOptionIds: _.map(this.initialSelectedOptionIds, (id) => parseInt(id)),
    };
  },

  methods: {
    formatTagGroups(data) {
      return _.map(data, (rawTagGroup) => {
        rawTagGroup.options = _.clone(rawTagGroup.tags);
        delete rawTagGroup.tags;
        return rawTagGroup;
      });
    },
  },
});
